import * as React from "react";
import { Star } from "lucide-react";
import { Separator } from "@/components/ui/separator";
const stats = [{
  value: "12+ Years",
  label: "Proven Track Record"
}, {
  value: "99.95%",
  label: "Uptime Guarantee"
}, {
  value: "50+",
  label: "Agencies Served"
}, {
  value: "24/7",
  label: "Dedicated Support"
}];
export default function PublicTrustMetrics() {
  return <section id="public-trust-metrics" className="bg-background py-16 border-y border-border">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div className="flex flex-col xl:flex-row items-center justify-between gap-12 xl:gap-8">
          
          {}
          <div className="flex flex-col items-center xl:items-start gap-3 shrink-0">
            <span className="text-sm font-semibold text-muted-foreground uppercase tracking-widest">
              Reviewed On
            </span>
            <div className="flex items-center gap-2">
              <span className="text-3xl font-bold text-foreground tracking-tight">
                Trustpilot
              </span>
            </div>
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map(i => <div key={i} data-index={i} className="bg-secondary p-1 rounded-sm">
                  <Star className="w-4 h-4 text-secondary-foreground fill-current" />
                </div>)}
            </div>
            <span className="text-sm font-medium text-muted-foreground mt-1">
              5.0 Rating • Based on verified reviews
            </span>
          </div>

          {}
          <div className="flex flex-col md:flex-row items-center justify-center xl:justify-end w-full flex-1">
            {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col md:flex-row items-center w-full md:w-auto">
                <div className="flex flex-col items-center text-center py-8 md:py-0 px-4 lg:px-8 xl:px-10">
                  <span className="text-5xl font-bold text-primary tracking-tighter">
                    {stat.value}
                  </span>
                  <span className="text-sm font-semibold uppercase text-muted-foreground mt-3 tracking-wider">
                    {stat.label}
                  </span>
                </div>
                
                {}
                {i < stats.length - 1 && <>
                    <Separator orientation="vertical" className="hidden md:block h-20 bg-border" />
                    <Separator orientation="horizontal" className="md:hidden w-full max-w-[200px] bg-border" />
                  </>}
              </div>)}
          </div>

        </div>
      </div>
    </section>;
}